module.exports = __webpack_public_path__ + "static/media/mlr_status_draft.4a70553e.svg";